import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
  background-color: var(--gray100);
`
export const ContentActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
